import { http } from "@/utils/index";

export function uploadImage() {
  return http.request("post", "/upload/image", {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function saveHomeBanner(data) {
  return http.request("post", "/home/banner", {
    data,
  });
}

export function leftLikeDict(key) {
  return http.request("get", "/dict/leftLike", {
    params: {
      key,
    },
  });
}

export function leftLikeDicts(keys) {
  return http.request("get", "/dict/leftLikes/" + keys.join(","), {});
}

export function saveDict(data) {
  return http.request("post", "/dict/save", {
    data,
  });
}

// 根据前缀删除
export function deleteDict(key) {
  return http.request("delete", "/dict/delete", {
    params: {
      key,
    },
  });
}

export function saveChildrenDict(data) {
  return http.request("post", "/dict/children/save", {
    data,
  });
}

export function deleteChildrenDict(key) {
  return http.request("delete", "/dict/children/delete", {
    params: {
      key,
    },
  });
}

export function getHomeBanner() {
  return http.request("get", "/home/banner", {});
}

// 友情链接
export function getAllLinks() {
  return http.request("get", "/link", {});
}

export function createLink(data) {
  return http.request("post", "/link", {
    data,
  });
}

export function deleteLink(id) {
  return http.request("delete", "/link/" + id, {});
}

export function addSubscribe(data) {
  return http.request("post", "/subscribe", {
    data,
  });
}

// 获取前端菜单树
export function getMenuFrontTree() {
  return http.request("get", "/menu/front/tree");
}

// 获取产品列表
// export function getProductList() {
//   return http.request("get", "/product/list");
// }

// 查询产品列表
export function getProductList(productType) {
  return http.request("get", "/product/getByType", {
    params: { productType }
  });
}

export function getProductDetail(productNo) {
  return http.request("get", "/product/getByNo", {
    params: { productNo }
  });
}

export function getHotProductListByNos(productNo) {
  return http.request("get", "/product/getHotProductListByNos", {
    params: { productNo }
  });
}

// 获取关联产品
export function getRelationProduct(productNo) {
  return http.request("get", "/product/getRelation", {
    params: { productNo }
  });
}

// 获取关联产品
export function getProductQuote(message) {
  return http.request("get", "/product/getProductQuote", {
    params: { message }
  });
}

export function getSubscribeExhibition(email) {
  return http.request("get", "/product/getSubscribeExhibition", {
    params: { email }
  });
}
export function getJoinOurNetwork(email) {
  return http.request("get", "/product/getJoinOurNetwork", {
    params: { email }
  });
}

export function getHotProductList() {
  return http.request("get", "/hotProduct/list");
}

export function getMainProducts() {
  return http.request("get", "/product/getMainProducts");
}